import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiURL } from "../../config";
import { setUser } from "../../redux/userSlice";
import { useDispatch } from "react-redux";
import { newConversation } from "../../redux/conversationIdSlice";

function RegisterForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    //console.log(`Username : ${username}\nPassword: ${password}`)
    const response = await fetch(`${apiURL}/api/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
      credentials: "include",
    });

    const data = await response.json();
    //console.log(data)
    if (data.message === "SUCCESS") {
      dispatch(setUser({ _id: data.user._id, username: data.user.username }));
      dispatch(newConversation());
      navigate("/");
    } else {
      setFeedback(data.content);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        handleSubmit(e);
      }}
      className="space-y-6"
    >
      <div className="mb-3">
        <label
          htmlFor="formBasicEmail"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          Username
        </label>
        <input
          type="text"
          id="formBasicEmail"
          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          placeholder="Username"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
          }}
        />
      </div>

      <div className="mb-3">
        <label
          htmlFor="formBasicPassword"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          Password
        </label>
        <input
          type="password"
          id="formBasicPassword"
          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
      </div>
      <div className="text-red-500 mb-8">{feedback}</div>
      <button
        type="submit"
        className="text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
      >
        Login
      </button>
    </form>
  );
}

export default RegisterForm;
